import actions from '../constants/actionTypes';
import request from '../utils/request';
import { isSuccess } from '../utils/utils';
import { setGeneralError } from './components/UniversalModal/actions';
import { trans } from '../localization';

export function finishInitApp() {
  return {
    type: actions.FINISH_INIT_APP,
  };
}

export function startAppLoading() {
  return {
    type: actions.START_APP_LOADING,
  };
}

export function stopAppLoading() {
  return {
    type: actions.STOP_APP_LOADING,
  };
}

export function toggleSidebarMenu(isShow = false) {
  return {
    type: actions.SET_SIDEBAR_COLLAPSE,
    response: isShow,
  };
}

function receiveTableMetaData(response) {
  return {
    type: actions.TABLE_META_DATA_RECEIVED,
    response,
  };
}

export function getListRestaurant() {
  return async dispatch => {
    dispatch(startAppLoading());
    try {
      const response = await request.getMerchant('/api/user/get_restaurants');
      if (isSuccess(response)) {
        const { restaurants } = response.reply;
        return dispatch({
          type: actions.SET_LIST_RESTAURANT,
          response: {
            restaurants: restaurants.sort((a, b) => {
              const nameA = a.name.toLowerCase();
              const nameB = b.name.toLowerCase();
              return nameA.localeCompare(nameB);
            }),
          },
        });
      }
      return dispatch(setGeneralError(response.result));
    } finally {
      dispatch(stopAppLoading());
    }
  };
}

export function getListOwnerMerchantInfo() {
  return async dispatch => {
    dispatch(startAppLoading());
    try {
      const response = await request.postTableNow(
        '/api/merchant_tool/get_own_merchant_infos',
      );
      if (isSuccess(response)) {
        const { merchant_infos: merchantTableInfos } = response.reply;
        dispatch({
          type: actions.RECEIVE_LIST_TABLE_RESTAURANTS,
          response: {
            merchantTableInfos,
          },
        });
      } else {
        dispatch(setGeneralError(trans(response.result)));
      }
    } finally {
      dispatch(stopAppLoading());
    }
  };
}

export function getSetting() {
  return dispatch =>
    request.postMerchant('/api/user/get_settings').then(response => {
      if (isSuccess(response)) {
        const { settings } = response.reply;
        dispatch({
          type: actions.SET_SETTING_USER,
          response: {
            setting: settings,
          },
        });
      } else {
        dispatch(setGeneralError(response.result));
      }
    });
}

export function getNowPortalMetadata() {
  return dispatch => {
    request.getPortal('/wallet_in_merchant/meta/').then(response => {
      if (isSuccess(response)) {
        dispatch({
          type: actions.RECEIVE_NOW_PORTAL_META_DATA,
          response: {
            metadata: response.reply,
          },
        });
      }
    });
  };
}

function getNowMetaData() {
  return async dispatch => {
    const response = await request.postMerchant('/api/meta/get');
    if (isSuccess(response)) {
      const { meta } = response.reply;
      dispatch({
        type: actions.GET_META_DATA,
        response: {
          metadata: meta,
        },
      });
      return;
    }
    dispatch(setGeneralError(response.result));
  };
}

function getTableMetaData() {
  return async dispatch => {
    const response = await request.postTableNow(
      '/api/merchant_tool/get_metadata',
    );
    if (isSuccess(response)) {
      dispatch(receiveTableMetaData(response));
      return;
    }
    dispatch(setGeneralError(response.result));
  };
}

export function getMetaData() {
  return async dispatch =>
    Promise.all([dispatch(getNowMetaData()), dispatch(getTableMetaData())]);
}

export function initializeApp() {
  return async dispatch => {
    try {
      await dispatch(getMetaData());
      await Promise.all([
        dispatch(getSetting()),
        dispatch(getListRestaurant()),
      ]);
      await Promise.all([
        dispatch(getListOwnerMerchantInfo()),
        dispatch(getNowPortalMetadata()),
      ]);
    } finally {
      dispatch(finishInitApp());
    }
  };
}



// WEBPACK FOOTER //
// ./foody/src/layout/actions.js